import { useState } from "react"
import { ReactionAPI } from "../../apis/reaction/ReactionAPI";
import './rating.css'

const reaction = {
    good: "+1",
    bad: "-1"
}

const Rating = (props) => {
    const { messageId } = props;
    const [ratingSent, setRatingSent] = useState(false);
    const [buttonClicked, setButtonClicked] = useState('');

    const sendReaction = (reaction) => {
        setRatingSent(true);
        ReactionAPI.sendReaction(reaction, messageId).catch(() => {/*do nothing*/});
        setButtonClicked(reaction);
    }

    if (null === messageId) {
        return null;
    }

    return (
        <div className="rating-container">
            <div className="rating-good">
                <button
                    className={buttonClicked === '+1' ? 'clicked' : null}
                    onClick={(e) => sendReaction(reaction.good)}
                    disabled={ratingSent}
                >
                    &#x1F44D;
                </button>
            </div>
            <div className="rating-bad">
                <button
                    className={buttonClicked === '-1' ? 'clicked' : null} 
                    onClick={() => sendReaction(reaction.bad)} 
                    disabled={ratingSent}
                >
                    &#x1F44E;
                </button>
            </div>
        </div>
    );
}

export default Rating